import { SpcTogglesPos } from '../types/spc.js';
import { NUM_SPC_CHECKS, SPC_ENABLED_DEFAULT } from './spcConstants.js';


export function defaultSpcToggles(): SpcTogglesPos {
    // return Array(NUM_SPC_CHECKS).fill(SPC_ENABLED_DEFAULT)
    return [...Array(NUM_SPC_CHECKS).fill(SPC_ENABLED_DEFAULT)] as SpcTogglesPos;
}
